@if (note && index !== undefined) {
    <div class="mainContainer">
        <div class="detailsContainer">
            <div>
                <p>Created by</p>
                <span>{{ note.userFirstName + ' ' + note.userLastName }}</span>
            </div>
            <div>
                <p>Created on</p>
                <span>{{ note.creationDate | date }}</span>
            </div>
            <div>
                <p>Last modified</p>
                <span>{{ note.modificationDate | date }}</span>
            </div>
            @if (note.noteUsers?.length) {
                <div class="teamAssigned">
                    <p>Addressed to</p>
                    @for (user of note.noteUsers; track user.noteId) {
                        <lib-badge [text]="user.userFullName"></lib-badge>
                    }
                </div>
            }
        </div>
        <div class="messageContainer">
            <div class="header">
                <p class="title">{{ note.title }}</p>
                @if (canEditNote) {
                    <app-kebab-menu>
                        <button role="menuitem" class="resetStyles" (click)="editNote(index)">Edit</button>
                        <button role="menuitem" class="resetStyles" (click)="removeNote(note.id, index)">Remove</button>
                    </app-kebab-menu>
                }
            </div>
            <div class="message">{{ note.message }}</div>
        </div>
    </div>
}
